export default {"src":"/_next/static/media/404.e5bb3566.svg","height":165,"width":268};